@if (editMode && userAccount) {
  <form
    #form
    [formGroup]="myForm"
    [ngClass]="{ vertical: alignment === 'vertical' }"
  >
    <div class="edit-form celo-input-outline">
      @if (canLookup) {
        <mat-form-field [hidden]="true" class="form-field">
          <input
            matInput
            placeholder="patientidValid"
            name="patientidValid"
            #patientidValid
            formControlName="patientidValid"
          />
        </mat-form-field>
      }
      <div class="fw">
        <mat-form-field class="form-field patientid-field" appearance="outline">
          <mat-label>Patient ID</mat-label>
          <input
            matInput
            formControlName="uid"
            placeholder="Patient ID"
            name="uid"
            #patient_id
            [required]="!optionalId"
            (ngModelChange)="patientidEdited()"
          />
          @if (patient_id.value === "" && patientIdFocused) {
            <mat-hint>Required</mat-hint>
          }
          @if (patient_id.value && myForm.get("uid").errors?.maxlength) {
            <mat-hint>Too Long</mat-hint>
          }
          @if (canLookup) {
            <button
              mat-icon-button
              matSuffix
              class="lookup-button"
              (click)="patientIdLookup(patient_id.value)"
              matTooltip="Lookup Patient ID"
            >
              <mat-icon svgIcon="lookup-button"></mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="fw">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Last Name</mat-label>
          <input
            matInput
            placeholder="Last Name"
            name="lastName"
            formControlName="lastName"
          />
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>First Name</mat-label>
          <input
            matInput
            placeholder="First Name"
            name="firstName"
            formControlName="firstName"
          />
        </mat-form-field>
      </div>
      <mat-form-field class="form-field dob" appearance="outline">
        <mat-label>Date of Birth</mat-label>
        <input
          matInput
          [max]="today"
          [matDatepicker]="picker"
          [placeholder]="dobPlaceholder"
          name="dateOfBirth"
          formControlName="dateOfBirth"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint>Format as {{ dobPlaceholder }}</mat-hint>
        @if (
          myForm.controls["dateOfBirth"].hasError("matDatepickerParse") ||
          myForm.controls["dateOfBirth"].hasError("invalidDate")
        ) {
          <mat-error> Please enter a valid date. </mat-error>
        }
        @if (myForm.controls["dateOfBirth"].hasError("futureDate")) {
          <mat-error> Date of birth cannot be in the future. </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Gender</mat-label>
        <mat-select name="gender" formControlName="gender">
          @for (gender of genders; track gender) {
            <mat-option [value]="gender.value">
              {{ gender.viewValue }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (canSave) {
      <app-celo-cancel-save-buttons
        [showNow]="hasChanged && !saving"
        (cancelled)="cancel()"
        (save)="save()"
      >
      </app-celo-cancel-save-buttons>
    }
  </form>
}
@if (!editMode && myForm) {
  <div>
    @if (myForm.controls["uid"].value) {
      <div>
        @if (selectMode) {
          <div class="itemtitle font-14">
            <div>Patient details for {{ patient.uid }}</div>
            @if (patient.source && patient.source.name) {
              <div>
                {{ patient.source.name }}
              </div>
            }
          </div>
        }
        @for (field of fields; track field) {
          <div>
            @if (myForm.controls[field.key].value) {
              <div
                class="patient-field"
                [ngClass]="{ horizontal: alignment === 'horizontal' }"
              >
                <div class="font-14 font-grey fieldname">{{ field.name }}</div>
                <div
                  class="font-14"
                  [ngClass]="{ uppercase: field.key === 'uid' }"
                >
                  {{
                    myForm.controls[field.key].value
                      ? field.type !== "date"
                        ? myForm.controls[field.key].value
                        : (myForm.controls[field.key].value | dateFormat: "dateOfBirth")
                      : "Not Given"
                  }}
                </div>
              </div>
            }
          </div>
        }
        @if (showConsent && consent) {
          <div class="font-14 horizontal">
            <div class="font-grey fieldname">Consent</div>
            @if (consent) {
              <div>
                <div>
                  {{
                    consent.company && consent.company.name
                      ? consent.company.name
                      : "Consent attached"
                  }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (!myForm.controls["uid"].value) {
      <div class="font-grey font-14">No Patient Details</div>
    }
  </div>
}
